import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMarkup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"markup, marker, highlight"} maskId="square-filled-radius-0-stroke-1-IconMarkup"><path d="M15.3828 17.2695L13.708 20.1025H21V21.1025H3V17.8496L6.36621 12.1094L15.3828 17.2695Z" fill="currentColor"/><path d="M10.876 2.70996L21.6904 8.89844L16.8887 16.9785L5.64648 10.5449L10.4492 2.46484L10.876 2.70996Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMarkup;
